<template lang="html">
  <div class="breadcrumb" 
      :class="{show:isShow}">
    <div class="breadcrumb-wrap">
      <ul>
        <li class="fs14" v-for="(item,index) in levelList" :key="item.path">
          <router-link v-if="index!=levelList.length-1" :to="item.path" class="">{{$t(item.meta.key)}}</router-link> <i v-if="index!=levelList.length-1" class="el-icon-arrow-right"></i>
          <span v-if="index==levelList.length-1">{{$t(item.meta.key)}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
    name:'Breadcrumb',
    data() {
        return {
            hide:false,
            title: "",
            img:require('@/assets/breadcrumb/001.jpg'),
            levelList:null
        }
    },
    created(){
      this.getBreadcrumb()
    },
    computed:{
      background(){
        return 'url('+ this.img +') no-repeat'
      },
      isShow(){
        return this.levelList[this.levelList.length-1].path!='/index'&&!this.hide;
      }
    },
    methods:{
      getBreadcrumb() {
        let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
        // console.log(matched);
        // console.log(this.$route.query.type);
        if(matched.length===0){
          return false;
        }
        //四级页面导航
        if(matched[matched.length-1].path==='/dynamic/detail/:id'){
            this.levelList=[
              { path: '/index', meta: { title: '首页', key:'sidebar.index'}},
              { path: '/dynamic/news', meta: { title: '展会新闻', key:'sidebar.d_news'}},
              { path: '/dynamic/detail', meta: { title: '新闻详情', key:'sidebar.d_detail'}}
            ];
            if(this.$route.query.type === 'media'){
                this.levelList=[
                  { path: '/index', meta: { title: '首页', key:'sidebar.index'}},
                  { path: '/dynamic/media', meta: { title: '媒体报道', key:'sidebar.d_media'}},
                  { path: '/dynamic/detail', meta: { title: '新闻详情', key:'sidebar.d_detail'}}
                ];
            }
            if(this.$route.query.type === 'service'){
                this.levelList=[
                  { path: '/index', meta: { title: '首页', key:'sidebar.index'}},
                  { path: '/service', meta: { title: '观展服务', key:'sidebar.service'}},
                  { path: '/dynamic/detail', meta: { title: '详情', key:'sidebar.d_detail'}}
                ];
            }
            if(this.$route.query.type === 'ennews'){
                this.levelList=[
                  { path: '/index', meta: { title: '首页', key:'sidebar.index'}},
                  { path: '/news', meta: { title: '展会新闻', key:'sidebar.d_news'}},
                  { path: '/dynamic/detail', meta: { title: '详情', key:'sidebar.d_detail'}}
                ];
            }



          return false;
        }

        const first = matched[0]
        if (!this.isIndex(first)) {
          matched = [{ path: '/index', meta: { title: '首页', key:'sidebar.index' }}].concat(matched)
        }
        this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
       
        //参展商与产品页面隐藏
        if(/^\/seller/gi.test(matched[matched.length-1].path)){
          this.hide = true;
        }
        if(/^\/live/gi.test(matched[matched.length-1].path)){
          this.hide = true;
        }
      },
      isIndex(route) {
        const path = route && route.path
        // console.log(path);
        if (!path) {
          return false
        }
        // console.log(path.trim().toLocaleLowerCase() === '/index'.toLocaleLowerCase());
        return path.trim().toLocaleLowerCase() === '/index'.toLocaleLowerCase()
      }
    },
    watch: {
      $route() {
        this.getBreadcrumb()
      }
    }
}
</script>

<style scoped>
.hide{display:none;}
.breadcrumb{position: absolute; top:3.125vw; left:5.25vw; z-index:999; overflow: hidden; color:#fff; transition-duration: 500ms; opacity:0;}
.breadcrumb.show{opacity:1;}
.breadcrumb-wrap ul{display: flex;}

@media (max-width: 991px){
.breadcrumb{top:3.125vw; left:3.25vw;}
.breadcrumb .fs14{font-size:3.5vw; line-height:3.5vw;}
}
</style>

